import React from 'react'
import Navbar from '../components/Navbar';
import Footer from '../components/footer';
import HeroImg2 from '../components/HeroImg2';
import { FaWhatsapp } from 'react-icons/fa';
import Form from '../components/Form';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <div>
      <Navbar />
      <HeroImg2 heading="CONTACT" 
      text="Would Love To Chat? " 
      divs={
      <div><center>
        <h4>Leave a message on Whatsapp. We shall get to you shortly</h4>
        <h4><motion.a whileHover={{scale:2.1}} 
              target='_blank' rel="noreferrer"
              href='https://wa.me/237676648875?text=Hello I am here for'>
          <FaWhatsapp size={30} 
            style={{ color:'green',
              marginLeft:'1rem',
              marginRight:'5px'
          }}/>Send Message
          </motion.a></h4>
        </center></div>
      }/>
      <Form />
      <Footer />
    </div>
  )
}

export default Contact